import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { user } = useAuth();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src="/logo.svg" alt="Logo" className="h-10 w-10" />
              <span className="font-bold text-xl text-white">ИИ Говори</span>
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              Тренажёр для развития навыков общения с клиентами на базе искусственного интеллекта
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-4">Навигация</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-white transition-colors">Главная</Link></li>
              {user && <li><Link to="/scenarios" className="text-sm hover:text-white transition-colors">Сценарии</Link></li>}
              {user && <li><Link to="/achievements" className="text-sm hover:text-white transition-colors">Достижения</Link></li>}
              {user && <li><Link to="/profile" className="text-sm hover:text-white transition-colors">Профиль</Link></li>}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Контакты</h3>
            <ul className="space-y-2">
              <li><a href="mailto:info@profdialog.ru" className="text-sm hover:text-white transition-colors">info@profdialog.ru</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Компания</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>ООО "ПРОФДИАЛОГ"</li>
              <li>ИНН: 9724220085</li>
              <li>ОГРН: 1257700213088</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">© {currentYear} ООО "ПрофДиалог". Все права защищены.</p>
          <div className="flex items-center gap-6">
            <a href="/files/privacy-policy.pdf" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-white transition-colors">Политика конфиденциальности</a>
            <a href="/files/terms-of-use.pdf" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-white transition-colors">Условия использования</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
